import React, {useState, useEffect} from "react";
import TextField from "../../Components/TextField";
import ButtonContainer from "../../Components/ButtonContainer";
import COLORS from '../../Colors';
import * as Constants from '../../Utilities/Constants';

import { CognitoHelper } from '../../Utilities/CognitoHelper';

//props:
// goBack: function that takes no parameters that allows going back to the sign in page
export default function ForgotPassword(props) {
    let resetPasswordFields = {
        'email' : {
            "title": "Email",
            "placeholder": "Enter your email address",
            "id": "codeEmail",
            "type": "text",
            "focus": true
        },
        'emailCode' : {
            "title": "Email code",
            "placeholder": "Enter your the code sent to your e-mail address.",
            "id": "emailCode",
            "type": "text",
            "focus": true
        },
        'password' : {
            "title": "Password",
            "placeholder": "Enter a new password",
            "id": "signupPassword",
            "type": "password",
        },
    }

    const [currentErrors, setErrors] = useState({});

    const clear_errors = (id) => {
        if(currentErrors[id]) {
            let newErrors = {...currentErrors}
            delete newErrors[id]
            setErrors(newErrors)
        }
    }

    const keys = [Constants.EMAIL, 'emailCode', Constants.PASS]

    let resetInput = keys.map(function(key, index){
        let field = resetPasswordFields[key]
        let fieldKey = field.id + currentErrors

        return(
            <TextField
                frontLabel = {field.title}
                id = {field.id}
                placeholder = {field.placeholder}
                update_text = {() => clear_errors(field.id)}
                type={field.type}
                small = {true}
                bare = {true}
                key={fieldKey}
                readOnly={false}
                error = {currentErrors[field.id]}
                focus = {field.focus === true}
            />
        )

    });

    let resetForm = <div>
        {resetInput}
    </div>

    const resetClicked = async () => {
        let email = document.getElementById("codeEmail").value.toLowerCase();
        let emailCode = document.getElementById("emailCode").value.toLowerCase();
        let password = document.getElementById("signupPassword").value;

        const cognitoHelper = new CognitoHelper()

        cognitoHelper.confirmPassword(email, emailCode, password, {
            onFailure(err) {
                console.log(err);
            },
            onSuccess(message) {
                console.log(`Success: ${message}`);

                window.location.reload()
            },
        });
    }

    const [sentLink, setSentLink] = React.useState(false)

    const sendResetLink = () => {
        let email = document.getElementById("resetEmail").value;
        if (email.length > 0) {
            const cognitoHelper = new CognitoHelper()

            cognitoHelper.sendPasswordReset(email, function() {
                setSentLink(true);
            }, function(error) {
                console.log(error)

                alert(`Error resetting password: ${error}`)
            })
        } else {
            //TODO: why is this the only error, shouldn't we be telling them something else? is this already taken care of with errors?
            console.log("Please enter an email")
        }
    }

    let emailField = <TextField
        id = {"resetEmail"}
        placeholder = {"Email"}
        type={"text"}
        small = {true}
        readOnly={false}
        //TODO: figure out what I had meant this to be used for
        //error = {this.state.error ? questions[this.state.question_num]['error'] : ''}
    />

    return (
        <div>
            {sentLink ?
                <div>
                    <p>Please enter the code you received over e-mail and your new password below.</p>

                    {resetForm}

                    <ButtonContainer
                        colors={[COLORS.blue]}
                        buttonTexts={["Reset Password"]}
                        buttonType='filled'
                        onClick={resetClicked}
                        />
                </div> : <div>
                    <p>Enter your email to receive a password reset email.</p>

                    {emailField}

                    <ButtonContainer
                        colors={[COLORS.blue]}
                        buttonTexts={["Send Email"]}
                        buttonType='filled'
                        onClick={sendResetLink}
                    />
                </div> }

            <br />
            <button onClick={props.goBack}>Back</button>
        </div>
    );
}
